import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectLoaderStore = (state) => state.loader;

const makeSelectLoader = () => createSelector(
  selectLoaderStore,
  (loader) => ({ ...loader }),
);

export {
  makeSelectLoader,
  selectLoaderStore,
};
